import { Button, Form, FormControl } from "react-bootstrap";
import "./landing.page.scss";
import { CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import InputForm from "../components/input/input.component";
import IMG_COVER from "../assets/images/interview-ai-logo.png";
import { InputModel } from "../models/input.model";
import { v4 as uuidv4 } from 'uuid';
import IMG_JOBHACK from "../assets/images/logo-jobhack.png";
import { createRoom, generateQuestion, getPreFillResume, getQuestionPublic, getSummaryResume, saveLog, saveQuestionPublic, SendEmailDropCV, signIn, uploadResume } from "../services/interview-api.services";
import { ProfileResumeModel } from "../models/profile-resume.model";
import ConfirmInfoModal from "../modals/confirm-public.modal";
import LoadingModal from "../modals/loading.modal";
import { CandidatePublic } from "../models/candidate-public.model";
import { trackEvent } from "../utils/trackGA4.util";
import { GAConfig } from "../utils/ga-config.util";
import UtilityService from "../utils/ga4.util";
import Navbar from "../shared-component/Navbar";
import HeroSection from "../shared-component/HeroSection";
import ProblemSolutionSection from "../shared-component/ProblemSolutionSection";
import FeaturesSection from "../shared-component/FeaturesSection";
import TestimonialsSection from "../shared-component/TestimonialsSection";
import Footer from "../shared-component/Footer";
import config from "../config";
import { UtmObject } from "../models/utm-object.model";

const LandingPage = () => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fileUpload, setFileUpload] = useState<File | null>(null);
    const [isCreatingRoom, setIsCreatingRoom] = useState(false);
    const navigate = useNavigate();
    const [loadingMsg, setLoadingMsg] = useState('กำลังอัปโหลดเรซูเม่ (Uploading resume...)');
    const [formData, setFormData] = useState<ProfileResumeModel>();
    const [isConfirmData, setIsConfirmData] = useState(false);
    const [resumeKey, setResumeKey] = useState('');
    const [templateId, setTemplateId] = useState("");

    const location = useLocation(); // gives access to pathname and search params
    const [fullUrl, setFullUrl] = useState<string>("");
    const [utmObject, setUtmObject] = useState<UtmObject | null>(null);

    useEffect(() => {
        const { pathname, search } = location;
        const fullUrlMod = `${pathname}${search}`;
        setFullUrl(fullUrlMod);
        console.log(search)
        const searchParams = new URLSearchParams(search);
        const utmSource = searchParams.get("utm_source");
        const utmMedium = searchParams.get("utm_medium");

        if (utmSource?.trim() && utmMedium?.trim()) {
            console.log("✅ Valid UTM Source:", utmSource);
            console.log("✅ Valid UTM Medium:", utmMedium);
            setUtmObject({ utm_source: utmSource, utm_medium: utmMedium });
        } else {
            console.warn("⚠️ Missing or invalid UTM parameters");
        }
    }, [location]);

    function getFileExtension(fileName: string): string | null {
        // Use a regular expression to extract the file extension
        const match = fileName.match(/\.(\w+)$/);
        return match ? `.${match[1].toLowerCase()}` : null;
    }
    function getFileExtensionFromFile(file: File): string | null {
        return getFileExtension(file.name);
    }
    const getRandomBoolean = (): boolean => {
        return Math.random() < 0.5;
    };
    const submitFile = async (bodyInput: InputModel) => {
        console.log(bodyInput);
        setIsCreatingRoom(true);
        setIsLoading(true);
        setLoadingMsg("กำลังอัพโหลด Resume ...")
        try {

            if (getRandomBoolean()) {
                generateQuestion(bodyInput.jobTitle, bodyInput.experience).then((res) => {
                    if (res.message.questions) {
                        saveQuestionPublic(res.message.questions, bodyInput.jobTitle, bodyInput.experience).then((res) => {

                            console.log(res);
                            if (res) {
                                setIsCreatingRoom(false);
                                setTemplateId(res.data);
                                submit(bodyInput, res.data)
                            }


                        });
                    }
                }).catch((err) => {
                    setIsCreatingRoom(false);
                })
            } else {
                console.log("START RANDOM");
                getQuestionPublic(bodyInput.jobTitle, bodyInput.experience).then((res) => {
                    if (res) {
                        if (res.data) {
                            setIsCreatingRoom(false);
                            console.log(res.data);
                            setTemplateId(res.data.template_id);
                            submit(bodyInput, res.data)
                        } else {
                            generateQuestion(bodyInput.jobTitle, bodyInput.experience).then((res) => {
                                if (res.message.questions) {
                                    saveQuestionPublic(res.message.questions, bodyInput.jobTitle, bodyInput.experience).then((res) => {
                                        setIsCreatingRoom(false);
                                        setTemplateId(res.data);
                                        console.log(res);
                                        submit(bodyInput, res.data)
                                    });
                                }
                            }).catch((err) => {
                                setIsCreatingRoom(false);
                            })
                        }
                    }

                });
            }


        } catch (err) {
            console.log(err);
            setIsCreatingRoom(false);
        }





    }

    const submit = (bodyInput: InputModel, template_id: any) => { // Added type for template_id for clarity
        const id = uuidv4();
        const millisecondTimestamp = new Date(new Date().toISOString()).getTime();
        if (!bodyInput.resumeFile) {
            console.error("Resume file is missing");
            setIsCreatingRoom(false); // Ensure loading state is reset
            alert("กรุณาแนบไฟล์เรซูเม่ (Please attach a resume file)");
            return;
        }
        console.log(getFileExtensionFromFile(bodyInput.resumeFile));
        setFileUpload(bodyInput.resumeFile);
        const fileName = "resume-" + millisecondTimestamp + getFileExtensionFromFile(bodyInput.resumeFile);
        setIsLoading(true);
        uploadResume(bodyInput.resumeFile, fileName, "interview_ai").then((res) => {

            console.log(res);
            if (res) {
                trackEvent(GAConfig.action.uploadResume, UtilityService());
                setResumeKey(res.resume_key);
                const company_id = process.env.REACT_APP_ENVIRONMENT === "production" ? "12b1a948-80e0-4f92-859c-7ba2026ecf2d" : "ecbd7d09-d295-42b0-9bba-4f619e21b703";
                const job_question_id = process.env.REACT_APP_ENVIRONMENT === "production" ? "968c29e9-509a-4dfa-ae3b-3aee1e930a05" : "92a67014-445b-44ef-8540-b16671c61450";
                const inputField = {
                    company_id: company_id,
                    job_question_id: job_question_id,
                    event: "UPLOAD_RESUME",
                    type: "interview ai jobhack",
                    url: fullUrl,
                    utm_source: utmObject?.utm_source || "",
                    utm_medium: utmObject?.utm_medium || "",
                    log: "Upload Resume Complete",
                    resume_key:
                        res.resume_key
                }
                saveLog(inputField);
                SendEmailDropCV("INTERVIEW AI JOBHACK");
                try {
                    getPreFillResume(res.resume_key).then((profile) => {

                        if (profile) {
                            console.log(profile)
                            setIsConfirmData(true);
                            setIsLoading(false);
                            setFormData(profile);
                        }
                    }).catch((err) => {
                        alert("เกิดข้อผิดพลาดในการดึงข้อมูลเรซูเม่ (Error fetching resume data)");
                        setIsLoading(false);
                        // setIsConfirmData(true); // Consider if this should be true or false on error
                        setIsCreatingRoom(false); // Reset loading state
                        const form: ProfileResumeModel = {
                            email: "",
                            first_name: "",
                            last_name: "",
                            latest_job_title: "",
                            phone: "",
                        }
                        setFormData(form);
                    })
                } catch {
                    // setIsConfirmData(true); // Consider if this should be true or false on error
                    setIsLoading(false);
                    setIsCreatingRoom(false); // Reset loading state
                }



            }
        }).catch(err => {
            console.error("Error uploading resume:", err);
            alert("เกิดข้อผิดพลาดในการอัปโหลดเรซูเม่ (Error uploading resume)");
            setIsCreatingRoom(false); // Reset loading state
        });
    }
    const onConfirmData = (data: ProfileResumeModel) => {
        setIsLoading(true);
        setIsConfirmData(true);
        setLoadingMsg('กำลังสร้างห้องสัมภาษณ์ (Creating Room...)');
        if (resumeKey && fileUpload && templateId) {
            getSummaryResume(resumeKey).then((res) => {
                if (res.summary) {
                    console.log(res);

                    const newCandidate: CandidatePublic = {
                        firstname: data.first_name,
                        lastname: data.last_name,
                        email: data.email,
                        phone: data.phone,
                        status: "ACTIVE",
                        jobTitle: data.latest_job_title || "N/A", // Ensure jobTitle has a fallback
                        interview_start_date: new Date().toISOString(),
                        interview_end_date: new Date().toISOString(),
                        jobExp: 0,
                        resume: { key: resumeKey, filename: fileUpload.name, summary: res.summary, skills: res.skills },
                        candidate_id: ""
                    };

                    createRoom(newCandidate).then((roomRes) => { // Renamed 'res' to 'roomRes' to avoid conflict
                        if (roomRes["result"]?.candidate_id && roomRes["result"]?.company_id && roomRes["result"]?.job_question_id) {
                            console.log(roomRes);
                            trackEvent(GAConfig.action.createRoom, UtilityService());
                            navigate(`public/verify/${roomRes["result"].company_id}/${roomRes["result"].job_question_id}/${roomRes["result"].candidate_id}?app_id=INTERVIEW_AI&template_id=${templateId}`);
                            setIsLoading(false);
                        } else {
                            console.error("Failed to create room, missing IDs in response:", roomRes);
                            alert("เกิดข้อผิดพลาดในการสร้างห้องสัมภาษณ์: ข้อมูลไม่ครบถ้วน (Error creating room: Incomplete data)");
                            setIsLoading(false);
                        }
                    }).catch((err) => {
                        console.error("Error in createRoom API call:", err);
                        alert("เกิดข้อผิดพลาดในการสร้างห้องสัมภาษณ์ (Error creating interview room)");
                        setIsLoading(false);
                    })
                } else {
                    console.error("Failed to get summary resume");
                    alert("เกิดข้อผิดพลาดในการดึงข้อมูลสรุปเรซูเม่ (Error fetching resume summary)");
                    setIsLoading(false);
                }
            }
            ).catch((err) => {
                console.error("Error in getSummaryResume API call:", err);
                setIsLoading(false);
                alert("เกิดข้อผิดพลาดในการดึงข้อมูลสรุปเรซูเม่ (Error fetching resume summary)");
            })
        } else {
            console.warn("Missing resumeKey, fileUpload, or templateId. Cannot proceed with room creation.");
            alert("ข้อมูลไม่ครบถ้วน กรุณาลองใหม่อีกครั้ง (Incomplete data. Please try again.)");
            setIsLoading(false); // Ensure loading is stopped
            setIsCreatingRoom(false); // Also reset this if it was set
        }

    }


    return (
        <>

            <div className="bg-gradient-to-br from-slate-50 via-purple-50 to-pink-50 min-h-screen text-slate-700 snap-container">
                <Navbar />
                <main>
                    <HeroSection onSubmitFile={submitFile} />
                    <ProblemSolutionSection />
                    <FeaturesSection />
                    {/* <TestimonialsSection /> */}
                </main>
                <Footer />
            </div>

            {
                isCreatingRoom && loadingMsg &&
                <LoadingModal isOpen={isCreatingRoom} message={loadingMsg} onClose={() => setIsConfirmData(false)}></LoadingModal>
            }
            {
                isLoading && loadingMsg &&
                <LoadingModal isOpen={isLoading} message={loadingMsg} onClose={() => setIsLoading(false)}></LoadingModal>
            }
            {
                isConfirmData && formData &&
                <ConfirmInfoModal isOpen={isConfirmData} onClose={() => setIsConfirmData(false)} dataField={formData} onConfirmData={onConfirmData}></ConfirmInfoModal>
            }
        </>
    )
}

export default LandingPage;